// Generated by Avo VERSION 211.17.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "rRXgR746LPNvqYrUDGwv";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "JtBMqYk11NTg60uq2tZn",
          "br": "master",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "bJ0pj2RVS0ir3Kh8P6lq",
          "se": (new Date()).toISOString(),
          "so": "Koc0DYaqw",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "JtBMqYk11NTg60uq2tZn",
          "br": "master",
          "en": env,
          "ty": type,
          "sc": "bJ0pj2RVS0ir3Kh8P6lq",
          "se": (new Date()).toISOString(),
          "so": "Koc0DYaqw",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "bJ0pj2RVS0ir3Kh8P6lq",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export interface HEXResourceInventory {
  hexResourceType: HEXResourceTypeValueType
  amount: number
}

export interface HEXResourceUpdates {
  hexResourceType: HEXResourceTypeValueType
  amount: number
}

export interface RollingOfferSteps {
  paidStep: number
  totalPaidSteps: number
}

export interface OfferSegmentation {
  name: string
  value: string
}

export interface MetaProperties {
  metaPropertyName: string
  metaPropertyValue: string
}

export const GameSlug = {
  'UNSPECIFIED': 'unspecified',
  '2020_CONNECT': '2020-connect',
  'BEST_CLASSIC_MAHJONG_CONNECT': 'best-classic-mahjong-connect',
  'BUBBLE_SHOOTER_BLITZ': 'bubble-shooter-blitz',
  'INFINITE_BULLETS': 'infinite-bullets',
  'PUZZLE_BLOCKS': 'puzzle-blocks',
  'DAILY_SOLITAIRE': 'daily-solitaire',
  'JEWELS_BLITZ_FB': 'jewels-blitz-fb',
  'BUBBLE_SHOOTER_CLASSIC': 'bubble-shooter-classic',
  'MOJI': 'moji',
  'SOLITAIRE_GARDEN': 'solitaire-garden',
  'JEWELS_BLITZ_X': 'jewels-blitz-x',
  'YUMMY_TALES': 'yummy-tales',
  'BEST_CLASSIC_PYRAMID_SOLITAIRE': 'best-classic-pyramid-solitaire',
  'BEST_CLASSIC_SPIDER_SOLITAIRE': 'best-classic-spider-solitaire',
  'MY_LITTLE_GARDEN': 'my-little-garden',
  'FOREST_MATCH': 'forest-match',
  'SOLITAIRE_TRIPEAKS': 'solitaire-tripeaks',
  'BUBBLE_SHOOTER_PRO': 'bubble-shooter-pro',
  'SOLITAIRE_HOME_STORY': 'solitaire-home-story',
  'SOLITAIRE_HOME_STORY_MOBILE': 'solitaire-home-story-mobile',
  'SG_SOLITAIRE_CLASSIC': 'sg-solitaire-classic',
  'SOLITAIRE_MAHJONG_CLASSIC_2': 'solitaire-mahjong-classic-2',
  'TILE_QUEST': 'tile-quest',
  'SOLITAIRE_FARM_SEASONS': 'solitaire-farm-seasons',
  'SOLITAIRE_HOME_STORY_WEB': 'solitaire-home-story-web',
  'PUZZLE_BLOCKS_MOBILE': 'puzzle-blocks-mobile',
  'POP_IT': 'pop-it',
  'MATCH_3_GARDEN': 'match-3-garden',
  'CANDY_MATCH': 'candy-match',
  'FISH_STORY': 'fish-story',
  'CANDY_RAIN_5': 'candy-rain-5',
  'GARDEN_TALES': 'garden-tales',
  'COOKIE_CRUSH_2': 'cookie-crush-2',
  'JEWELS_KYODAI_MAHJONG': 'jewels-kyodai-mahjong',
  'SOLITAIRE_MAHJONG_CLASSIC': 'solitaire-mahjong-classic',
  'BUBBLE_SHOOTER_HD': 'bubble-shooter-hd',
  'UP_HILL_RACING_2': 'up-hill-racing-2',
  'BIKE_RACING': 'bike-racing',
  'PUZZLE_BLOCKS_CLASSIC': 'puzzle-blocks-classic',
  'BIKE_RACING_2': 'bike-racing-2',
  'BASKETBALL_ALL_STARS': 'basketball-all-stars',
  'BUTTERFLY_KYODAI': 'butterfly-kyodai',
  'JEWELS_BLITZ_5': 'jewels-blitz-5',
  'WOOD_BLOCK_PUZZLE': 'wood-block-puzzle',
  'GARDEN_TALES_3': 'garden-tales-3',
  'KINGS_RETURN': 'kings-return',
  'COOKIE_CRUSH_CHRISTMAS': 'cookie-crush-christmas',
  'SOLITAIRE_MAHJONG_JUICY': 'solitaire-mahjong-juicy',
  'TIMBERMEN_HALLOWEEN': 'timbermen-halloween',
  'TOUCH_AND_CATCH_SANTA': 'touch-and-catch-santa',
  'MAHJONG_3D_CONNECT': 'mahjong-3d-connect',
  'HEXA_STACK': 'hexa-stack',
  'TILE_HERO': 'tile-hero',
  'SOLITAIRE_HOME_STORY_IOS': 'solitaire-home-story-ios',
  'HEXA_STACK_MICROSOFT': 'hexa-stack-microsoft',
  'HEXA_STACK_SAMSUNG': 'hexa-stack-samsung',
  'SOLITAIRE_HOME_STORY_SAMSUNG': 'solitaire-home-story-samsung',
  'SOLITAIRE_HOME_STORY_MICROSOFT': 'solitaire-home-story-microsoft',
  'SOLITAIRE_TRIPEAKS_MICROSOFT': 'solitaire-tripeaks-microsoft',
  'SOLITAIRE_TRIPEAKS_SAMSUNG': 'solitaire-tripeaks-samsung',
  'TILE_HERO_ANDROID': 'tile-hero-android',
  'TILE_HERO_FACEBOOK': 'tile-hero-facebook',
  'TILE_HERO_IOS': 'tile-hero-ios',
  'TILE_HERO_WEB': 'tile-hero-web',
  'MATCHING_MOMENTS_FACEBOOK': 'matching-moments-facebook',
  'QUIZ': 'quiz',
  'HEXA_STACK_DISCORD': 'hexa-stack-discord',
  'SOLITAIRE_HOME_STORY_DISCORD': 'solitaire-home-story-discord',
  'BUBBLE_SHOOTER_HD_MICROSOFT': 'bubble-shooter-hd-microsoft',
  'BUBBLE_SHOOTER_PRO_MICROSOFT': 'bubble-shooter-pro-microsoft',
  'BUTTERFLY_KYODAI_HD_MICROSOFT': 'butterfly-kyodai-hd-microsoft',
  'DAILY_SOLITAIRE_CLASSIC_TOURNAMENT_MICROSOFT': 'daily-solitaire-classic-tournament-microsoft',
  'DAILY_SOLITAIRE_MICROSOFT': 'daily-solitaire-microsoft',
  'JEWELS_BLITZ_5_MICROSOFT': 'jewels-blitz-5-microsoft',
  'PUZZLE_BLOCKS_CLASSIC_MICROSOFT': 'puzzle-blocks-classic-microsoft',
  'SOLITAIRE_FARM_SEASONS_MICROSOFT': 'solitaire-farm-seasons-microsoft',
  'SOLITAIRE_MAHJONG_CLASSIC_MICROSOFT': 'solitaire-mahjong-classic-microsoft',
  'UP_HILL_RACING_2_MICROSOFT': 'up-hill-racing-2-microsoft',
  'WOOD_BLOCK_PUZZLE_MICROSOFT': 'wood-block-puzzle-microsoft',
  'SOLITAIRE_HOME_STORY_MS_STORE': 'solitaire-home-story-ms-store',
  'SOLITAIRE_MAHJONG_CLASSIC_FACEBOOK': 'solitaire-mahjong-classic-facebook',
  'HEXA_STACK_ANDROID': 'hexa-stack-android',
  'HEXA_STACK_IOS': 'hexa-stack-ios',
  'BUBBLE_SHOOTER_PRO_REDDIT': 'bubble-shooter-pro-reddit',
} as const;
export type GameSlugType = typeof GameSlug;
export type GameSlugValueType = GameSlugType[keyof GameSlugType];

export const UIElementAction = {
  'CLICK': 'Click',
  'VIEW': 'View',
} as const;
export type UIElementActionType = typeof UIElementAction;
export type UIElementActionValueType = UIElementActionType[keyof UIElementActionType];

export const PurchaseResponse = {
  'SUCCESS': 'Success',
  'ERROR': 'Error',
} as const;
export type PurchaseResponseType = typeof PurchaseResponse;
export type PurchaseResponseValueType = PurchaseResponseType[keyof PurchaseResponseType];

export const ResourceActionType = {
  'PURCHASE': 'Purchase',
  'REWARD': 'Reward',
  'AD': 'Ad',
  'INVENTORY': 'Inventory',
  'COIN_PURCHASE': 'Coin_Purchase',
  'TICKET_PURCHASE': 'Ticket_Purchase',
} as const;
export type ResourceActionTypeType = typeof ResourceActionType;
export type ResourceActionTypeValueType = ResourceActionTypeType[keyof ResourceActionTypeType];

export const AdNetwork = {
  'FACEBOOK': 'facebook',
  'UNITY': 'unity',
  'APP_LOVIN': 'appLovin',
  'SOFTGAMES': 'softgames',
  'AD_MOB': 'adMob',
  'DISCORD': 'discord',
  'GAME_SNACKS': 'gameSnacks',
  'MSN_PLAY': 'msnPlay',
  'SAMSUNG': 'samsung',
} as const;
export type AdNetworkType = typeof AdNetwork;
export type AdNetworkValueType = AdNetworkType[keyof AdNetworkType];

export const PaymentProvider = {
  'FACEBOOK': 'facebook',
  'APPLE': 'apple',
  'GOOGLEPLAY': 'googleplay',
  'XSOLLA': 'xsolla',
  'SAMSUNG': 'samsung',
  'DISCORD': 'discord',
  'GOOGLE_GAME_SNACKS': 'google game snacks',
  'MS_START': 'ms start',
  'MS_STORE': 'ms store',
  'MSN_PLAY': 'msn play',
} as const;
export type PaymentProviderType = typeof PaymentProvider;
export type PaymentProviderValueType = PaymentProviderType[keyof PaymentProviderType];

export const AdResponse = {
  'SUCCESS': 'Success',
  'CLOSED': 'Closed',
  'ERROR': 'Error',
  'SKIPPED': 'Skipped',
} as const;
export type AdResponseType = typeof AdResponse;
export type AdResponseValueType = AdResponseType[keyof AdResponseType];

export const OfferAction = {
  'CLICK': 'Click',
  'SHOW': 'Show',
} as const;
export type OfferActionType = typeof OfferAction;
export type OfferActionValueType = OfferActionType[keyof OfferActionType];

export const SplitTestDistribution = {
  'CONTROL': 'control',
  'TEST_1': 'test_1',
  'TEST_2': 'test_2',
  'TEST_3': 'test_3',
  'TEST_4': 'test_4',
  'TEST_5': 'test_5',
  'TEST_6': 'test_6',
  'TEST_7': 'test_7',
  'TEST_8': 'test_8',
  'TEST_9': 'test_9',
  'TEST_10': 'test_10',
} as const;
export type SplitTestDistributionType = typeof SplitTestDistribution;
export type SplitTestDistributionValueType = SplitTestDistributionType[keyof SplitTestDistributionType];

export const PlatformName = {
  'FACEBOOK': 'facebook',
  'GOOGLE_PLAY_STORE': 'google play store',
  'IOS_APP_STORE': 'ios app store',
  'SAMSUNG': 'samsung',
  'WEB': 'web',
  'MICROSOFT': 'microsoft',
  'DISCORD': 'discord',
  'GOOGLE_GAME_SNACKS': 'google game snacks',
  'MS_START': 'ms start',
  'MS_STORE': 'ms store',
  'MSN_PLAY': 'msn play',
  'REDDIT': 'reddit',
} as const;
export type PlatformNameType = typeof PlatformName;
export type PlatformNameValueType = PlatformNameType[keyof PlatformNameType];

export const SeasonPassStatusContext = {
  'SEASON_PASS_START': 'Season Pass Start',
  'POINTS_UPDATE': 'Points Update',
  'SEASON_PASS_PURCHASE': 'Season Pass Purchase',
  'SEASON_PASS_COMPLETE': 'Season Pass Complete',
} as const;
export type SeasonPassStatusContextType = typeof SeasonPassStatusContext;
export type SeasonPassStatusContextValueType = SeasonPassStatusContextType[keyof SeasonPassStatusContextType];

export const AssetQuality = {
  'LOW': 'Low',
  'HIGH': 'High',
} as const;
export type AssetQualityType = typeof AssetQuality;
export type AssetQualityValueType = AssetQualityType[keyof AssetQualityType];

export const BackendName = {
  'FIREBASE': 'firebase',
  'SOFTGAMES': 'softgames',
  'PLAYFAB': 'playfab',
} as const;
export type BackendNameType = typeof BackendName;
export type BackendNameValueType = BackendNameType[keyof BackendNameType];

export const Environment = {
  'PROD': 'prod',
  'DEV': 'dev',
} as const;
export type EnvironmentType = typeof Environment;
export type EnvironmentValueType = EnvironmentType[keyof EnvironmentType];

export const ProductType = {
  'CONSUMABLE': 'Consumable',
  'SUBSCRIBABLE': 'Subscribable',
} as const;
export type ProductTypeType = typeof ProductType;
export type ProductTypeValueType = ProductTypeType[keyof ProductTypeType];

export const SchemaVersion = {
  '143': '143',
} as const;
export type SchemaVersionType = typeof SchemaVersion;
export type SchemaVersionValueType = SchemaVersionType[keyof SchemaVersionType];

export const HEXResourceType = {
  'COIN': 'Coin',
  'BOOSTER_HAMMER': 'BoosterHammer',
  'BOOSTER_MOVE': 'BoosterMove',
  'BOOSTER_REDRAW': 'BoosterRedraw',
  'UNLIMITED_LIVES_MINUTES': 'UnlimitedLivesMinutes',
  'LIVES': 'Lives',
  'BOOSTER_UNDO': 'BoosterUndo',
  'PRE_GAME_BOOSTER_DOUBLE_TILE': 'PreGameBoosterDoubleTile',
  'PRE_GAME_BOOSTER_INSTANT_REFILL': 'PreGameBoosterInstantRefill',
  'PRE_GAME_BOOSTER_RAINBOW_STACK': 'PreGameBoosterRainbowStack',
  'UNLIMITED_PRE_GAME_BOOSTER_DOUBLE_TILE_MINUTES': 'UnlimitedPreGameBoosterDoubleTileMinutes',
  'UNLIMITED_PRE_GAME_BOOSTER_INSTANT_REFILL_MINUTES': 'UnlimitedPreGameBoosterInstantRefillMinutes',
  'UNLIMITED_PRE_GAME_BOOSTER_RAINBOW_STACK_MINUTES': 'UnlimitedPreGameBoosterRainbowStackMinutes',
  'FREE_SPIN': 'FreeSpin',
} as const;
export type HEXResourceTypeType = typeof HEXResourceType;
export type HEXResourceTypeValueType = HEXResourceTypeType[keyof HEXResourceTypeType];

export const AdType = {
  'INTERSTITIAL': 'Interstitial',
  'REWARDED': 'Rewarded',
  'REWARDED_INTERSTITIAL': 'Rewarded Interstitial',
} as const;
export type AdTypeType = typeof AdType;
export type AdTypeValueType = AdTypeType[keyof AdTypeType];

let sysSessionId: any;
let sysGameSlug: any;
let sysGameVersion: any;
let sysPlatformName: any;
let sysSchemaVersion: any;
let sysEnvironment: any;

export function setSystemProperties(properties: {sessionId: string;
    gameSlug: GameSlugValueType;
    gameVersion: string;
    platformName: PlatformNameValueType;
    schemaVersion: SchemaVersionValueType;
    environment: EnvironmentValueType}) {
if (properties.sessionId !== null && properties.sessionId !== undefined) {
  sysSessionId = properties.sessionId;
}
if (properties.gameSlug !== null && properties.gameSlug !== undefined) {
  sysGameSlug = properties.gameSlug;
}
if (properties.gameVersion !== null && properties.gameVersion !== undefined) {
  sysGameVersion = properties.gameVersion;
}
if (properties.platformName !== null && properties.platformName !== undefined) {
  sysPlatformName = properties.platformName;
}
if (properties.schemaVersion !== null && properties.schemaVersion !== undefined) {
  sysSchemaVersion = properties.schemaVersion;
}
if (properties.environment !== null && properties.environment !== undefined) {
  sysEnvironment = properties.environment;
}
}

let Softgames: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    systemProperties: {sessionId: string;
    gameSlug: GameSlugValueType;
    gameVersion: string;
    platformName: PlatformNameValueType;
    schemaVersion: SchemaVersionValueType;
    environment: EnvironmentValueType},
    destinationOptions: any,
    SoftgamesDestination: CustomDestination) {
if (__AVO_ENV__ !== null) {
  return;
}
__AVO_ENV__ = options.env;
if (options.avoLogger !== undefined) {
  __AVO_LOGGER__ = options.avoLogger;
}
if (options.noop === true) {
  __AVO_NOOP__ = true;
}
if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
  InternalAvoLogger.warn("[avo] ****************************************************");
  InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
  InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
  InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
  InternalAvoLogger.warn("[avo] ****************************************************");
  __AVO_NOOP__ = false;
}
if (__AVO_NOOP__) {
  InternalAvoLogger.log("[avo] ****************************************************");
  InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
  InternalAvoLogger.log("[avo] - No events will be sent");
  InternalAvoLogger.log("[avo] - No network requests are made");
  InternalAvoLogger.log("[avo] ****************************************************");
}
if (options.strict !== undefined) {
  __STRICT__ = options.strict !== false;
}
if (options.reportFailureAs !== undefined) {
  __REPORT_FAILURE_AS__ = options.reportFailureAs;
}
__WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
if (!__AVO_NOOP__ && options.inspector !== undefined) {
  __INSPECTOR__ = options.inspector;
} else if (__AVO_ENV__ !== 'prod') {
  InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
}

setSystemProperties(systemProperties);

destinationOptions = destinationOptions || {};

if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
  
}
if (!__AVO_NOOP__) {
  if (__AVO_ENV__ === AvoEnv.Prod) {
}
if (__AVO_ENV__ === AvoEnv.Dev) {
}

Softgames = SoftgamesDestination;
if (__AVO_ENV__ === 'prod') {
  Softgames && Softgames.make && Softgames.make(__AVO_ENV__, null);
} else if (__AVO_ENV__ === 'dev') {
  Softgames && Softgames.make && Softgames.make(__AVO_ENV__, null);
} else {
  console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Softgames. Head to destination settings in Avo to set a staging key.");
  Softgames && Softgames.make && Softgames.make(__AVO_ENV__, null);
}
if (__AVO_ENV__ === AvoEnv.Dev) {
  // debug console in Avo
  _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
}
}
}

function assertHEXResourceInventory(hexResourceInventory: HEXResourceInventory[],
    _label?: string) {
let messages: AvoAssertMessage[] = [];
messages = messages.concat(AvoAssert.assertList("TCii5yrRnFFtdnNc181cs", "HEX Resource Inventory", hexResourceInventory));
if (hexResourceInventory !== null && hexResourceInventory !== undefined && hexResourceInventory.forEach) {
  hexResourceInventory.forEach(function (value, index) {
    messages = messages.concat(AvoAssert.assertObject("TCii5yrRnFFtdnNc181cs", "item at index " + index + " in HEX Resource Inventory", value));
});
}
return messages;
}

function assertHEXResourceUpdatesOptional(hexResourceUpdates: HEXResourceUpdates[] | null | undefined,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
if (hexResourceUpdates !== undefined && hexResourceUpdates !== null) {
  messages = messages.concat(AvoAssert.assertList("UKpFRKPC0", "HEX Resource Updates", hexResourceUpdates));
  hexResourceUpdates.forEach(function (value, index) {
    messages = messages.concat(AvoAssert.assertObject("UKpFRKPC0", "item at index " + index + " in HEX Resource Updates", value));
});
}
return messages;
}

function assertRollingOfferStepsOptional(rollingOfferSteps: RollingOfferSteps | null | undefined,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
if (rollingOfferSteps !== undefined && rollingOfferSteps !== null) {
  messages = messages.concat(AvoAssert.assertObject("l1tzEfh_X6oNX9j9IwQI7", _label ? "Rolling Offer Steps" + ': ' + _label : "Rolling Offer Steps", rollingOfferSteps));
}
return messages;
}

function assertOfferSegmentationOptional(offerSegmentation: OfferSegmentation[] | null | undefined,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
if (offerSegmentation !== undefined && offerSegmentation !== null) {
  messages = messages.concat(AvoAssert.assertList("mcwTOSg7fE3vdE4jyqaoL", "Offer Segmentation", offerSegmentation));
  offerSegmentation.forEach(function (value, index) {
    messages = messages.concat(AvoAssert.assertObject("mcwTOSg7fE3vdE4jyqaoL", "item at index " + index + " in Offer Segmentation", value));
});
}
return messages;
}

function assertMetaPropertiesOptional(metaProperties: MetaProperties[] | null | undefined,
    _label?: string) {
let messages: AvoAssertMessage[] = [];
if (metaProperties !== undefined && metaProperties !== null) {
  messages = messages.concat(AvoAssert.assertList("tV7TWP7c1", "Meta Properties", metaProperties));
  metaProperties.forEach(function (value, index) {
    messages = messages.concat(AvoAssert.assertObject("tV7TWP7c1", "item at index " + index + " in Meta Properties", value));
});
}
return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
__AVO_LOGGER__ = avoLogger;
}

export interface GameInitializedProperties {
  browserName: string | null | undefined;
  browserVersion: string | null | undefined;
  systemLocale: string | null | undefined;
  osName: string | null | undefined;
  osVersion: string | null | undefined;
  timeZoneName: string | null | undefined;
  timeZone: number | null | undefined;
  deviceType: string | null | undefined;
  deviceVendor: string | null | undefined;
  deviceModel: string | null | undefined;
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  newPlayer: boolean;
  entryPointName: string | null | undefined;
  timeSinceStartup: number | null | undefined;
  backendName: BackendNameValueType | null | undefined;
  backendUserId: string | null | undefined;
  profileId: string;
  platformUserId: string | null | undefined;
  sessionCounter: number | null | undefined;
  entryPointData: string | null | undefined;
  userFingerprint: string | null | undefined;
  maxTextureSize: number | null | undefined;
  affiliateId: string | null | undefined;
  publisherUserId: string | null | undefined;
  assetQuality: AssetQualityValueType | null | undefined;
}
/**
 * Game Initialized: Fires after the game connected to the backend and finished the initialisation of the player profile.
 * 
 * @param properties the properties associated with this event
 * @param properties.browserName: The browser name as provided by the user agent.
 * @param properties.browserVersion: The browser version as provided by the user agent.
 * @param properties.systemLocale: System locale of the device
 * @param properties.osName: Name of the operating system
 * @param properties.osVersion: Operating system version
 * @param properties.timeZoneName: Name of the zone (AEST etc..)
 * @param properties.timeZone: UTC time zone (-3, +2 etc..)
 * @param properties.deviceType: Type of the device
 * @param properties.deviceVendor: Vendor of the device
 * @param properties.deviceModel: Model specification of the device (high variance,  needs to be grouped/standardized in backend)
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.newPlayer: Indicates whether a user is playing for the first time
 * @param properties.entryPointName: Entry point as returned by the FB SDK
 * @param properties.timeSinceStartup: Time in seconds from moment the game has started until the current event is sent.
 * @param properties.backendName: The authentication backend where the user profile is stored.
 * @param properties.backendUserId: The user ID on the backend where the user profile is stored (associated with 'Backend Name' property)
 * @param properties.profileId: Unique tracking Id for the user that must be persisted in the user profile. This is generated on the client on first start, when the profile is created. It is NOT the facebook or game backend user ID.
 * @param properties.platformUserId: User Id given by the respective publishing platform (e.g. Facebook, Google Play, iOS Appstore, etc)
 * @param properties.sessionCounter: Incremental session counter, persisted in the player profile.
 * @param properties.entryPointData: JSON object with specific entry point properties as returned by the FB SDK
 * @param properties.userFingerprint: A unique identifier for a user to track users across games, typically based on a salted hash of the user email.
 * @param properties.maxTextureSize: The largest supported texture size as returned by the WebGLRenderingContext using getParameter(gl.MAX_TEXTURE_SIZE)
 * https://registry.khronos.org/webgl/specs/latest/1.0/#5.14.3
 * @param properties.affiliateId: The Id of the affiliate by which the user entered the game for the first time
 * @param properties.publisherUserId: The user's id from an external publisher
 * @param properties.assetQuality: Describes what version of assets are being served to the user. (i..e. low or high)
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/mdZU_5FwjxP}
 */
export function gameInitialized(properties: GameInitializedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
properties.browserName !== undefined && properties.browserName !== null ?
  eventPropertiesArray.push({id: "PvkE4N5RmG", name: "Browser Name", value: properties.browserName}) :
  eventPropertiesArray.push({id: "PvkE4N5RmG", name: "Browser Name", value: null});
properties.browserVersion !== undefined && properties.browserVersion !== null ?
  eventPropertiesArray.push({id: "1zFX7Qgmr_", name: "Browser Version", value: properties.browserVersion}) :
  eventPropertiesArray.push({id: "1zFX7Qgmr_", name: "Browser Version", value: null});
properties.systemLocale !== undefined && properties.systemLocale !== null ?
  eventPropertiesArray.push({id: "I94Xksxdd4", name: "System Locale", value: properties.systemLocale}) :
  eventPropertiesArray.push({id: "I94Xksxdd4", name: "System Locale", value: null});
properties.osName !== undefined && properties.osName !== null ?
  eventPropertiesArray.push({id: "CAGTeR9Kq0", name: "OS Name", value: properties.osName}) :
  eventPropertiesArray.push({id: "CAGTeR9Kq0", name: "OS Name", value: null});
properties.osVersion !== undefined && properties.osVersion !== null ?
  eventPropertiesArray.push({id: "xgwj56YMz", name: "OS Version", value: properties.osVersion}) :
  eventPropertiesArray.push({id: "xgwj56YMz", name: "OS Version", value: null});
properties.timeZoneName !== undefined && properties.timeZoneName !== null ?
  eventPropertiesArray.push({id: "yEjy5yIpg6", name: "Time Zone Name", value: properties.timeZoneName}) :
  eventPropertiesArray.push({id: "yEjy5yIpg6", name: "Time Zone Name", value: null});
properties.timeZone !== undefined && properties.timeZone !== null ?
  eventPropertiesArray.push({id: "OAi3oEvLFt", name: "Time Zone", value: properties.timeZone}) :
  eventPropertiesArray.push({id: "OAi3oEvLFt", name: "Time Zone", value: null});
properties.deviceType !== undefined && properties.deviceType !== null ?
  eventPropertiesArray.push({id: "TiC6ymZVUi", name: "Device Type", value: properties.deviceType}) :
  eventPropertiesArray.push({id: "TiC6ymZVUi", name: "Device Type", value: null});
properties.deviceVendor !== undefined && properties.deviceVendor !== null ?
  eventPropertiesArray.push({id: "wm_ot_7-pU", name: "Device Vendor", value: properties.deviceVendor}) :
  eventPropertiesArray.push({id: "wm_ot_7-pU", name: "Device Vendor", value: null});
properties.deviceModel !== undefined && properties.deviceModel !== null ?
  eventPropertiesArray.push({id: "rB4xlS-LDe", name: "Device Model", value: properties.deviceModel}) :
  eventPropertiesArray.push({id: "rB4xlS-LDe", name: "Device Model", value: null});
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "vRDzqTLnQK", name: "New Player", value: properties.newPlayer});
properties.entryPointName !== undefined && properties.entryPointName !== null ?
  eventPropertiesArray.push({id: "xJRXoM1u9_", name: "Entry Point Name", value: properties.entryPointName}) :
  eventPropertiesArray.push({id: "xJRXoM1u9_", name: "Entry Point Name", value: null});
properties.timeSinceStartup !== undefined && properties.timeSinceStartup !== null ?
  eventPropertiesArray.push({id: "SSRyFPUR3-", name: "Time Since Startup", value: properties.timeSinceStartup}) :
  eventPropertiesArray.push({id: "SSRyFPUR3-", name: "Time Since Startup", value: null});
properties.backendName !== undefined && properties.backendName !== null ?
  eventPropertiesArray.push({id: "k7RcwDqCeH", name: "Backend Name", value: properties.backendName}) :
  eventPropertiesArray.push({id: "k7RcwDqCeH", name: "Backend Name", value: null});
properties.backendUserId !== undefined && properties.backendUserId !== null ?
  eventPropertiesArray.push({id: "jZsMoOtc70", name: "Backend User Id", value: properties.backendUserId}) :
  eventPropertiesArray.push({id: "jZsMoOtc70", name: "Backend User Id", value: null});
eventPropertiesArray.push({id: "65oO39qmo5", name: "Profile Id", value: properties.profileId});
properties.platformUserId !== undefined && properties.platformUserId !== null ?
  eventPropertiesArray.push({id: "Ck6Iwq-4GU", name: "Platform User Id", value: properties.platformUserId}) :
  eventPropertiesArray.push({id: "Ck6Iwq-4GU", name: "Platform User Id", value: null});
properties.sessionCounter !== undefined && properties.sessionCounter !== null ?
  eventPropertiesArray.push({id: "bxw6NnSnSk", name: "Session Counter", value: properties.sessionCounter}) :
  eventPropertiesArray.push({id: "bxw6NnSnSk", name: "Session Counter", value: null});
properties.entryPointData !== undefined && properties.entryPointData !== null ?
  eventPropertiesArray.push({id: "omyftFoKIG", name: "Entry Point Data", value: properties.entryPointData}) :
  eventPropertiesArray.push({id: "omyftFoKIG", name: "Entry Point Data", value: null});
properties.userFingerprint !== undefined && properties.userFingerprint !== null ?
  eventPropertiesArray.push({id: "LNLNJe171", name: "User Fingerprint", value: properties.userFingerprint}) :
  eventPropertiesArray.push({id: "LNLNJe171", name: "User Fingerprint", value: null});
properties.maxTextureSize !== undefined && properties.maxTextureSize !== null ?
  eventPropertiesArray.push({id: "mgQxv84TU", name: " Max Texture Size", value: properties.maxTextureSize}) :
  eventPropertiesArray.push({id: "mgQxv84TU", name: " Max Texture Size", value: null});
properties.affiliateId !== undefined && properties.affiliateId !== null ?
  eventPropertiesArray.push({id: "NKgHAojT9", name: "Affiliate Id", value: properties.affiliateId}) :
  eventPropertiesArray.push({id: "NKgHAojT9", name: "Affiliate Id", value: null});
properties.publisherUserId !== undefined && properties.publisherUserId !== null ?
  eventPropertiesArray.push({id: "qSDK80Apj-", name: "Publisher User Id", value: properties.publisherUserId}) :
  eventPropertiesArray.push({id: "qSDK80Apj-", name: "Publisher User Id", value: null});
properties.assetQuality !== undefined && properties.assetQuality !== null ?
  eventPropertiesArray.push({id: "k02lu4ZiHk", name: "Asset Quality", value: properties.assetQuality}) :
  eventPropertiesArray.push({id: "k02lu4ZiHk", name: "Asset Quality", value: null});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "mdZU_5FwjxP", "2fe2ad66b45c0047a84555ed6dd4e93ffda9181b5469b56b063ba1b0061cb34b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Game Initialized", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("mdZU_5FwjxP", "Game Initialized", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Game Initialized': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Game Initialized", eventProperties, "mdZU_5FwjxP", "2fe2ad66b45c0047a84555ed6dd4e93ffda9181b5469b56b063ba1b0061cb34b");
}
// destination Softgames
Softgames.logEvent("Game Initialized", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PurchaseFinishedProperties {
  productId: string;
  transactionId: string | null | undefined;
  currencyCode: string;
  productPrice: string;
  errorMessage: string | null | undefined;
  sandboxPurchase: boolean | null | undefined;
  purchaseResponse: PurchaseResponseValueType;
  purchaseReceipt: string | null | undefined;
  paymentProvider: PaymentProviderValueType;
  storeEntryPoint: string | null | undefined;
  productPriceAmount: number;
  productType: ProductTypeValueType;
  platformProductId: string;
  purchaseToken: string | null | undefined;
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  gameArea: string | null | undefined;
  offerImpressionId: string | null | undefined;
  rollingOfferSteps: RollingOfferSteps | null | undefined;
}
/**
 * Purchase Finished: Fires when a transaction completed
 * 
 * @param properties the properties associated with this event
 * @param properties.productId: The ID of the IAP as defined internally at Softgames, to have a unified handle of a product across different platforms.
 * @param properties.transactionId: Unique transaction identifier for a single purchase within the IAP process, e.g. the paymentID in case of Facebook.
 * @param properties.currencyCode: 3-digit ISO Currency string of the current purchase
 * @param properties.productPrice: The product price as a string, as defined in the product catalog.
 * @param properties.errorMessage: A message describing why a process failed.
 * @param properties.sandboxPurchase: Boolean value that indicates whether the purchase was real or not (Sandbox Purchases - Test Purchases are flagged here)
 * @param properties.purchaseResponse: String value that indicates whether the purchase was successfully completed or not.
 * @param properties.purchaseReceipt: The purchase receipt as returned by the payment provider. Usually a Base64 encoded SHA256 hash of the payment information, used for server sided receipt validation.
 * @param properties.paymentProvider: Indicates whether the payment was done using Facebook, Google Play, Apple or another service provider
 * @param properties.storeEntryPoint: The specific 'call for action' that led the user to the purchase dialog.
 * This can provide a more detailed granularity than  Game Area (I.e. focus on an offer popup or a loss aversion popup that led user in the store to make the purchase).
 * @param properties.productPriceAmount: The numeric price of a product
 * @param properties.productType: The Type of the IAP as defined in the respective store
 * @param properties.platformProductId: The ID of the IAP as defined in the respective store
 * @param properties.purchaseToken: Unique ID of the purchase derived from the Store tracking only.
 * For Google Play Store payment it will be purchaseToken from payment data.
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.gameArea: Area of the game from where the event was triggered
 * @param properties.offerImpressionId: Unique identifier of the impression. Generated at Show. Should be later send with Click and Purchase Finished event as well.
 * @param properties.rollingOfferSteps: Describes how many paid steps there are in a Rolling Offer and what Paid Step was purchased.
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/Vp5zFmVzDtl}
 */
export function purchaseFinished(properties: PurchaseFinishedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "ZNrRISMpO2", name: "Product Id", value: properties.productId});
  properties.transactionId !== undefined && properties.transactionId !== null ?
    eventPropertiesArray.push({id: "asmftv_hZQ", name: "Transaction Id", value: properties.transactionId}) :
    eventPropertiesArray.push({id: "asmftv_hZQ", name: "Transaction Id", value: null});
  eventPropertiesArray.push({id: "rJSKviH02a", name: "Currency Code", value: properties.currencyCode});
  eventPropertiesArray.push({id: "DMgxIRxK07", name: "Product Price", value: properties.productPrice});
  properties.errorMessage !== undefined && properties.errorMessage !== null ?
    eventPropertiesArray.push({id: "bVayHrru51", name: "Error Message", value: properties.errorMessage}) :
    eventPropertiesArray.push({id: "bVayHrru51", name: "Error Message", value: null});
  properties.sandboxPurchase !== undefined && properties.sandboxPurchase !== null ?
    eventPropertiesArray.push({id: "57h2w2O41", name: "Sandbox Purchase", value: properties.sandboxPurchase}) :
    eventPropertiesArray.push({id: "57h2w2O41", name: "Sandbox Purchase", value: null});
  eventPropertiesArray.push({id: "7x04RYDVr", name: "Purchase Response", value: properties.purchaseResponse});
  properties.purchaseReceipt !== undefined && properties.purchaseReceipt !== null ?
    eventPropertiesArray.push({id: "PwLYdcf3o", name: "Purchase Receipt", value: properties.purchaseReceipt}) :
    eventPropertiesArray.push({id: "PwLYdcf3o", name: "Purchase Receipt", value: null});
  eventPropertiesArray.push({id: "OMHjmD3IF", name: "Payment Provider", value: properties.paymentProvider});
  properties.storeEntryPoint !== undefined && properties.storeEntryPoint !== null ?
    eventPropertiesArray.push({id: "aT-7BjxVF", name: "Store Entry Point", value: properties.storeEntryPoint}) :
    eventPropertiesArray.push({id: "aT-7BjxVF", name: "Store Entry Point", value: null});
  eventPropertiesArray.push({id: "dq_Rj32A3", name: "Product Price Amount", value: properties.productPriceAmount});
  eventPropertiesArray.push({id: "lbtwVEj89", name: "Product Type", value: properties.productType});
  eventPropertiesArray.push({id: "Rk3TaPSak1igeIFFFfOFN", name: "Platform Product ID", value: properties.platformProductId});
  properties.purchaseToken !== undefined && properties.purchaseToken !== null ?
    eventPropertiesArray.push({id: "v5sjq6I2tBjvdqo-7sENK", name: "Purchase Token", value: properties.purchaseToken}) :
    eventPropertiesArray.push({id: "v5sjq6I2tBjvdqo-7sENK", name: "Purchase Token", value: null});
  eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
  properties.metaProperties !== undefined && properties.metaProperties !== null ?
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
        "Meta Property Name": value.metaPropertyName,
        "Meta Property Value": value.metaPropertyValue,
      }
    })}) :
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
  properties.gameArea !== undefined && properties.gameArea !== null ?
    eventPropertiesArray.push({id: "4552BqnTK8", name: "Game Area", value: properties.gameArea}) :
    eventPropertiesArray.push({id: "4552BqnTK8", name: "Game Area", value: null});
  properties.offerImpressionId !== undefined && properties.offerImpressionId !== null ?
    eventPropertiesArray.push({id: "INzWGmsjWZqUtcQ40834F", name: "Offer Impression Id", value: properties.offerImpressionId}) :
    eventPropertiesArray.push({id: "INzWGmsjWZqUtcQ40834F", name: "Offer Impression Id", value: null});
  properties.rollingOfferSteps !== undefined && properties.rollingOfferSteps !== null ?
    eventPropertiesArray.push({id: "l1tzEfh_X6oNX9j9IwQI7", name: "Rolling Offer Steps", value: {
      "Paid Step": properties.rollingOfferSteps.paidStep,
      "Total Paid Steps": properties.rollingOfferSteps.totalPaidSteps,
    }}) :
    eventPropertiesArray.push({id: "l1tzEfh_X6oNX9j9IwQI7", name: "Rolling Offer Steps", value: null});
  eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
  eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
  eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
  eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
  eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
  eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
    messages = messages.concat(assertRollingOfferStepsOptional(properties.rollingOfferSteps));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Vp5zFmVzDtl", "f26bf5dbaafba1669404838d44c02a97a8671032de69bbb0f68d8a1e53bf318a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Purchase Finished", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Vp5zFmVzDtl", "Purchase Finished", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Purchase Finished': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Purchase Finished", eventProperties, "Vp5zFmVzDtl", "f26bf5dbaafba1669404838d44c02a97a8671032de69bbb0f68d8a1e53bf318a");
    }
    // destination Softgames
    Softgames.logEvent("Purchase Finished", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AdFinishedProperties {
  adType: AdTypeValueType;
  adNetwork: AdNetworkValueType;
  adId: string;
  adPlacementId: string;
  adSlotName: string;
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  adResponse: AdResponseValueType;
  errorMessage: string | null | undefined;
  countRetries: number | null | undefined;
  adShowDelay: number | null | undefined;
}
/**
 * Ad Finished: Fires at the moment when a user finished watching an ad and returns to the game. 
 * 
 * @param properties the properties associated with this event
 * @param properties.adType: Ad type
 * @param properties.adNetwork: Name of the ad network provider
 * @param properties.adId: The unique identifier (UUID) of an ad instance, generated on the client side. This is used to track the lifecycle of an ad, starting from the request over preloading and showing an ad.
 * @param properties.adPlacementId: The persistent identifier for an ad placement, as defined by the respective ad network provider like e.g. Facebook or AdMob.
 * @param properties.adSlotName: The unique name for a place (slot) inside the game where an ad is shown. Use this name to compare the performance of ads across the different areas in the game, depending on where they are shown.
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.adResponse: The specific response code how the Ad playback function returned.
 * @param properties.errorMessage: A message describing why a process failed.
 * @param properties.countRetries: Number of retries for a specific action.
 * @param properties.adShowDelay: Waiting time [SECONDS] for the user between the initial call to AdShow and the Ad starting to play. This duration may include the actual network request, potential retries, downloading the ad or falling through to cross promo or final fallback.
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/KZEnBYJPoU}
 */
export function adFinished(properties: AdFinishedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "zlMl3Uf-wQ", name: "Ad Type", value: properties.adType});
eventPropertiesArray.push({id: "O6mrBfY1FU", name: "Ad Network", value: properties.adNetwork});
eventPropertiesArray.push({id: "_GaSiwtCM0", name: "Ad Id", value: properties.adId});
eventPropertiesArray.push({id: "r80Q9aJ8e", name: "Ad Placement Id", value: properties.adPlacementId});
eventPropertiesArray.push({id: "XO1UyY2x6", name: "Ad Slot Name", value: properties.adSlotName});
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "Rfrle2QVYL", name: "Ad Response", value: properties.adResponse});
properties.errorMessage !== undefined && properties.errorMessage !== null ?
  eventPropertiesArray.push({id: "bVayHrru51", name: "Error Message", value: properties.errorMessage}) :
  eventPropertiesArray.push({id: "bVayHrru51", name: "Error Message", value: null});
properties.countRetries !== undefined && properties.countRetries !== null ?
  eventPropertiesArray.push({id: "82maSD1FY", name: "Count Retries", value: properties.countRetries}) :
  eventPropertiesArray.push({id: "82maSD1FY", name: "Count Retries", value: null});
properties.adShowDelay !== undefined && properties.adShowDelay !== null ?
  eventPropertiesArray.push({id: "xtImei0uE", name: "Ad Show Delay", value: properties.adShowDelay}) :
  eventPropertiesArray.push({id: "xtImei0uE", name: "Ad Show Delay", value: null});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "KZEnBYJPoU", "39556bbf4148ff26cc34640ac174c652f5996716af7921ebb2d121216f408db8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Ad Finished", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("KZEnBYJPoU", "Ad Finished", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Ad Finished': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Ad Finished", eventProperties, "KZEnBYJPoU", "39556bbf4148ff26cc34640ac174c652f5996716af7921ebb2d121216f408db8");
}
// destination Softgames
Softgames.logEvent("Ad Finished", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SplitTestProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  splitTestDistribution: SplitTestDistributionValueType;
  splitTestSlug: string;
}
/**
 * Split Test: Fires every time at startup when detected to be assigned to an active split test distribution.
 * As long as the state of a split test distribution is ACTIVE, the event should be fired every time at startup (1 event per active distribution, if multiple are active at the same time). If the state turns to INACTIVE, the event should simply not be sent anymore for that distribution.
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.splitTestDistribution: The name of the specific distribution group of a split test, the user has been assigned. If the split test has 2 distributions, the name should be one of the allowed values: control,test_1,...,test_10.
 * @param properties.splitTestSlug: The unique ID of the split test, as defined in the Split Test Admin tool https://st-admin.sbs.softgames.de/
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/vRxsJFLWJF}
 */
export function splitTest(properties: SplitTestProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "_RX6kZHI6e", name: "Split Test Distribution", value: properties.splitTestDistribution});
eventPropertiesArray.push({id: "ALWACJ4SMf", name: "Split Test Slug", value: properties.splitTestSlug});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "vRxsJFLWJF", "7c0e6e339af499bde591edb8202821df7573c6d6605fb9267b3c6b8e2abfbcbe", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Split Test", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("vRxsJFLWJF", "Split Test", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Split Test': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Split Test", eventProperties, "vRxsJFLWJF", "7c0e6e339af499bde591edb8202821df7573c6d6605fb9267b3c6b8e2abfbcbe");
}
// destination Softgames
Softgames.logEvent("Split Test", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface CheatsEnabledProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
}
/**
 * Cheats Enabled: Event fired every time a user uses a cheat code.
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/DHZGxyro4l}
 */
export function cheatsEnabled(properties: CheatsEnabledProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
  properties.metaProperties !== undefined && properties.metaProperties !== null ?
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
        "Meta Property Name": value.metaPropertyName,
        "Meta Property Value": value.metaPropertyValue,
      }
    })}) :
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
  eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
  eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
  eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
  eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
  eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
  eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "DHZGxyro4l", "bf51e453c26704c8957538ec6bcd200d2f35f7cc0bd25b927c822e8cf07b86ee", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Cheats Enabled", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("DHZGxyro4l", "Cheats Enabled", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Cheats Enabled': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Cheats Enabled", eventProperties, "DHZGxyro4l", "bf51e453c26704c8957538ec6bcd200d2f35f7cc0bd25b927c822e8cf07b86ee");
    }
    // destination Softgames
    Softgames.logEvent("Cheats Enabled", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NativeAppLaunchedProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  appBuildNumber: number;
  appVersion: string;
  memoryTotal: number | null | undefined;
  memoryAvailable: number | null | undefined;
  assetQuality: AssetQualityValueType | null | undefined;
  deviceIdentifier: string;
}
/**
 * Native App Launched: Fires right after the native mobile application was launched.
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.appBuildNumber: The build number on iOS or Google Play store
 * @param properties.appVersion: Version as shown on the iOS or Google Play store
 * @param properties.memoryTotal: Total amount of memory(mb) on the users device.
 * @param properties.memoryAvailable: The available memory(mb) on the users device. This is calculated as (Total Memory - Used Memory)
 * @param properties.assetQuality: Describes what version of assets are being served to the user. (i..e. low or high)
 * @param properties.deviceIdentifier: A unique identifier to identify a mobile device across sessions. This is required by Adjust, to match devices during the attribution process and also identify churning.
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/eXia8xYcRX}
 */
export function nativeAppLaunched(properties: NativeAppLaunchedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
  properties.metaProperties !== undefined && properties.metaProperties !== null ?
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
        "Meta Property Name": value.metaPropertyName,
        "Meta Property Value": value.metaPropertyValue,
      }
    })}) :
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
  eventPropertiesArray.push({id: "EsR9mNvnq", name: "App Build Number", value: properties.appBuildNumber});
  eventPropertiesArray.push({id: "87ZVkrfDz", name: "App Version", value: properties.appVersion});
  properties.memoryTotal !== undefined && properties.memoryTotal !== null ?
    eventPropertiesArray.push({id: "pmUDcQOjIi", name: "Memory Total", value: properties.memoryTotal}) :
    eventPropertiesArray.push({id: "pmUDcQOjIi", name: "Memory Total", value: null});
  properties.memoryAvailable !== undefined && properties.memoryAvailable !== null ?
    eventPropertiesArray.push({id: "Jg_E3OFeWB", name: "Memory Available", value: properties.memoryAvailable}) :
    eventPropertiesArray.push({id: "Jg_E3OFeWB", name: "Memory Available", value: null});
  properties.assetQuality !== undefined && properties.assetQuality !== null ?
    eventPropertiesArray.push({id: "k02lu4ZiHk", name: "Asset Quality", value: properties.assetQuality}) :
    eventPropertiesArray.push({id: "k02lu4ZiHk", name: "Asset Quality", value: null});
  eventPropertiesArray.push({id: "6bGy2-uxJz7TFIGBSn-yt", name: "Device Identifier", value: properties.deviceIdentifier});
  eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
  eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
  eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
  eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
  eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
  eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "eXia8xYcRX", "901306d3014d644edc5374db3fe0b93b8274f8e4e379f22ea26d67e6fe040206", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Native App Launched", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("eXia8xYcRX", "Native App Launched", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Native App Launched': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Native App Launched", eventProperties, "eXia8xYcRX", "901306d3014d644edc5374db3fe0b93b8274f8e4e379f22ea26d67e6fe040206");
    }
    // destination Softgames
    Softgames.logEvent("Native App Launched", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UIInteractionProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  uiElementId: string;
  uiElementAction: UIElementActionValueType;
  contextName: string;
}
/**
 * UI Interaction: Fires when an interaction with UI element occurs.
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.uiElementId: Id of the UI element (e.g. Close Button, Event Button, CTA, ...).
 * @param properties.uiElementAction: Tracked action of the UI Element ('Click', 'View').
 * @param properties.contextName: A unique slug to identify the specific context in which the event was triggered.
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/vd5kBMtfeX}
 */
export function uiInteraction(properties: UIInteractionProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "DQbONy-ZD", name: "UI Element ID", value: properties.uiElementId});
eventPropertiesArray.push({id: "02U6stcYV", name: "UI Element Action", value: properties.uiElementAction});
eventPropertiesArray.push({id: "hPd7B4v6pY", name: "Context Name", value: properties.contextName});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "vd5kBMtfeX", "e30d50282a145cb943c6f0dda926b5d108b4354189689322a769d57883e0230d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("UI Interaction", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("vd5kBMtfeX", "UI Interaction", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'UI Interaction': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("UI Interaction", eventProperties, "vd5kBMtfeX", "e30d50282a145cb943c6f0dda926b5d108b4354189689322a769d57883e0230d");
}
// destination Softgames
Softgames.logEvent("UI Interaction", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PlayerAttributionProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  attributionPayload: string;
  attributionNetwork: string | null | undefined;
  attributionCampaign: string | null | undefined;
}
/**
 * Player Attribution: Sent immediately when attribution data are collected and ready to be sent on each app/session start.
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.attributionPayload: Payload containing attribution data provided by a network (Facebook, Unity, Google).
 * @param properties.attributionNetwork: The name of the network to which the device is currently attributed.
 * @param properties.attributionCampaign: The name of the campaign to which the device is currently attributed.
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/1fzg2RLU1X}
 */
export function playerAttribution(properties: PlayerAttributionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
  properties.metaProperties !== undefined && properties.metaProperties !== null ?
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
        "Meta Property Name": value.metaPropertyName,
        "Meta Property Value": value.metaPropertyValue,
      }
    })}) :
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
  eventPropertiesArray.push({id: "DWZ2kNIeI", name: "Attribution Payload", value: properties.attributionPayload});
  properties.attributionNetwork !== undefined && properties.attributionNetwork !== null ?
    eventPropertiesArray.push({id: "i4XwerJq8", name: "Attribution Network", value: properties.attributionNetwork}) :
    eventPropertiesArray.push({id: "i4XwerJq8", name: "Attribution Network", value: null});
  properties.attributionCampaign !== undefined && properties.attributionCampaign !== null ?
    eventPropertiesArray.push({id: "hPa6kPIjt", name: "Attribution Campaign", value: properties.attributionCampaign}) :
    eventPropertiesArray.push({id: "hPa6kPIjt", name: "Attribution Campaign", value: null});
  eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
  eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
  eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
  eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
  eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
  eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1fzg2RLU1X", "6f3ea7fad4611ef69188599c8486045439447b1265b927392f86d72d712ce12e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Player Attribution", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1fzg2RLU1X", "Player Attribution", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Player Attribution': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Player Attribution", eventProperties, "1fzg2RLU1X", "6f3ea7fad4611ef69188599c8486045439447b1265b927392f86d72d712ce12e");
    }
    // destination Softgames
    Softgames.logEvent("Player Attribution", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HEXLevelStartedProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  levelNumber: number;
  lives: number;
  levelAttemptId: string;
  levelId: string;
  hexTileRvAmount: number;
}
/**
 * HEX Level Started: Level started event for Hexa Stack. Called only in a session where new level (s) are started. If a previous session / level was continued this will not be called again until a new level is started.
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.levelNumber: The number of the level
 * @param properties.lives: Players current amount of lives.
 * @param properties.levelAttemptId: Unique identifier of a single level attempt (to map Level Started, Level Finished and other events)
 * @param properties.levelId: Unique and persistent identifier of a single level (independent of an attempt)
 * @param properties.hexTileRvAmount: Amount of tiles that can be unlocked by rewarded ads
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/Hi0qDqEta5}
 */
export function hexLevelStarted(properties: HEXLevelStartedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "bP1jHNEg5", name: "Level Number", value: properties.levelNumber});
eventPropertiesArray.push({id: "Z07VW_DAh", name: "Lives", value: properties.lives});
eventPropertiesArray.push({id: "YigUD3Pqm", name: "Level Attempt Id", value: properties.levelAttemptId});
eventPropertiesArray.push({id: "YyMk6EdDUR", name: "Level Id", value: properties.levelId});
eventPropertiesArray.push({id: "DBmfB2eiV", name: "HEX Tile RV Amount", value: properties.hexTileRvAmount});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "Hi0qDqEta5", "31208bb7481db7f6e2b1cc44f99caf3c76d2a84b1a91242848c5a42965ef0a98", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("HEX Level Started", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("Hi0qDqEta5", "HEX Level Started", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'HEX Level Started': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("HEX Level Started", eventProperties, "Hi0qDqEta5", "31208bb7481db7f6e2b1cc44f99caf3c76d2a84b1a91242848c5a42965ef0a98");
}
// destination Softgames
Softgames.logEvent("HEX Level Started", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface HEXLevelWonProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  levelNumber: number;
  levelScore: number;
  lives: number;
  hexDoubleRewardShown: boolean;
  levelAttemptId: string;
  levelId: string;
  hexResourceInventory: HEXResourceInventory[];
  hexResourceUpdates: HEXResourceUpdates[] | null | undefined;
}
/**
 * HEX Level Won: Level Won event for Hexa Stack
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.levelNumber: The number of the level
 * @param properties.levelScore: User's score at the end of a level
 * @param properties.lives: Players current amount of lives.
 * @param properties.hexDoubleRewardShown: Was double reward option available
 * @param properties.levelAttemptId: Unique identifier of a single level attempt (to map Level Started, Level Finished and other events)
 * @param properties.levelId: Unique and persistent identifier of a single level (independent of an attempt)
 * @param properties.hexResourceInventory: A list of the current amount of each resource in the user's inventory.
 * @param properties.hexResourceUpdates: A list of sink/source actions, that affected to amount of Resources in the user's inventory.
 * Amount should be negative for CONSUMED resources and positive for RECEIVED resources.
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/HvbdzBfu_}
 */
export function hexLevelWon(properties: HEXLevelWonProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "bP1jHNEg5", name: "Level Number", value: properties.levelNumber});
eventPropertiesArray.push({id: "O2Nd-Jhuq", name: "Level Score", value: properties.levelScore});
eventPropertiesArray.push({id: "Z07VW_DAh", name: "Lives", value: properties.lives});
eventPropertiesArray.push({id: "5txr1tN93D", name: "HEX Double Reward Shown", value: properties.hexDoubleRewardShown});
eventPropertiesArray.push({id: "YigUD3Pqm", name: "Level Attempt Id", value: properties.levelAttemptId});
eventPropertiesArray.push({id: "YyMk6EdDUR", name: "Level Id", value: properties.levelId});
eventPropertiesArray.push({id: "TCii5yrRnFFtdnNc181cs", name: "HEX Resource Inventory", value: properties.hexResourceInventory.map(function(value) { return {
    "HEX Resource Type": value.hexResourceType,
    "Amount": value.amount,
}
})});
properties.hexResourceUpdates !== undefined && properties.hexResourceUpdates !== null ?
  eventPropertiesArray.push({id: "UKpFRKPC0", name: "HEX Resource Updates", value: properties.hexResourceUpdates.map(function(value) { return {
      "HEX Resource Type": value.hexResourceType,
      "Amount": value.amount,
  }
})}) :
eventPropertiesArray.push({id: "UKpFRKPC0", name: "HEX Resource Updates", value: null});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  messages = messages.concat(assertHEXResourceInventory(properties.hexResourceInventory));
  messages = messages.concat(assertHEXResourceUpdatesOptional(properties.hexResourceUpdates));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "HvbdzBfu_", "78f650c21bafc8cd41cbf56eb3f3b6559f870b6bfd89571d913ab4ab7d0a9de7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("HEX Level Won", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("HvbdzBfu_", "HEX Level Won", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'HEX Level Won': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("HEX Level Won", eventProperties, "HvbdzBfu_", "78f650c21bafc8cd41cbf56eb3f3b6559f870b6bfd89571d913ab4ab7d0a9de7");
}
// destination Softgames
Softgames.logEvent("HEX Level Won", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface HEXLevelLostProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  levelScore: number;
  levelNumber: number;
  lives: number;
  levelAttemptId: string;
  levelId: string;
}
/**
 * HEX Level Lost: Level Lost event for Hexa Stack
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.levelScore: User's score at the end of a level
 * @param properties.levelNumber: The number of the level
 * @param properties.lives: Players current amount of lives.
 * @param properties.levelAttemptId: Unique identifier of a single level attempt (to map Level Started, Level Finished and other events)
 * @param properties.levelId: Unique and persistent identifier of a single level (independent of an attempt)
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/qnbkf8FO68}
 */
export function hexLevelLost(properties: HEXLevelLostProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "O2Nd-Jhuq", name: "Level Score", value: properties.levelScore});
eventPropertiesArray.push({id: "bP1jHNEg5", name: "Level Number", value: properties.levelNumber});
eventPropertiesArray.push({id: "Z07VW_DAh", name: "Lives", value: properties.lives});
eventPropertiesArray.push({id: "YigUD3Pqm", name: "Level Attempt Id", value: properties.levelAttemptId});
eventPropertiesArray.push({id: "YyMk6EdDUR", name: "Level Id", value: properties.levelId});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "qnbkf8FO68", "e8a68bcaac6a7953dd00d40e03581d15f2654e68fda88c4acca24d5076e95c08", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("HEX Level Lost", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("qnbkf8FO68", "HEX Level Lost", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'HEX Level Lost': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("HEX Level Lost", eventProperties, "qnbkf8FO68", "e8a68bcaac6a7953dd00d40e03581d15f2654e68fda88c4acca24d5076e95c08");
}
// destination Softgames
Softgames.logEvent("HEX Level Lost", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface HEXReviveShownProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  levelNumber: number;
  levelScore: number;
}
/**
 * HEX Revive Shown: Loss aversion "revive shown" event for Hexa Stack. Called when the revive option is shown from the level failed screen.
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.levelNumber: The number of the level
 * @param properties.levelScore: User's score at the end of a level
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/RX1Eg9ycPg}
 */
export function hexReviveShown(properties: HEXReviveShownProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "bP1jHNEg5", name: "Level Number", value: properties.levelNumber});
eventPropertiesArray.push({id: "O2Nd-Jhuq", name: "Level Score", value: properties.levelScore});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "RX1Eg9ycPg", "8c53cb07fe79c01d5faccd680685ccf6019f2ff2083c0a356157097925138a5d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("HEX Revive Shown", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("RX1Eg9ycPg", "HEX Revive Shown", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'HEX Revive Shown': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("HEX Revive Shown", eventProperties, "RX1Eg9ycPg", "8c53cb07fe79c01d5faccd680685ccf6019f2ff2083c0a356157097925138a5d");
}
// destination Softgames
Softgames.logEvent("HEX Revive Shown", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface HEXReviveUsedProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  levelNumber: number;
  levelScore: number;
  resourceActionType: ResourceActionTypeValueType;
  hexResourceUpdates: HEXResourceUpdates[] | null | undefined;
}
/**
 * HEX Revive Used: Loss aversion "revive used" event for Hexa Stack. Called when the revive option is used from the level failed screen.
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.levelNumber: The number of the level
 * @param properties.levelScore: User's score at the end of a level
 * @param properties.resourceActionType: Denotes the type of sink/source transaction that modified any resource in the user's inventory. For example watching an ad, purchasing an IAP or consuming a booster.
 * @param properties.hexResourceUpdates: A list of sink/source actions, that affected to amount of Resources in the user's inventory.
 * Amount should be negative for CONSUMED resources and positive for RECEIVED resources.
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/Yq8h0YyrdD}
 */
export function hexReviveUsed(properties: HEXReviveUsedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "bP1jHNEg5", name: "Level Number", value: properties.levelNumber});
eventPropertiesArray.push({id: "O2Nd-Jhuq", name: "Level Score", value: properties.levelScore});
eventPropertiesArray.push({id: "KG11eHIZr", name: "Resource Action Type", value: properties.resourceActionType});
properties.hexResourceUpdates !== undefined && properties.hexResourceUpdates !== null ?
  eventPropertiesArray.push({id: "UKpFRKPC0", name: "HEX Resource Updates", value: properties.hexResourceUpdates.map(function(value) { return {
      "HEX Resource Type": value.hexResourceType,
      "Amount": value.amount,
  }
})}) :
eventPropertiesArray.push({id: "UKpFRKPC0", name: "HEX Resource Updates", value: null});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  messages = messages.concat(assertHEXResourceUpdatesOptional(properties.hexResourceUpdates));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "Yq8h0YyrdD", "2489dd029ea1c209dc608b5e55fe00baa58d6677a7d8c0c3793437a76675dfc2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("HEX Revive Used", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("Yq8h0YyrdD", "HEX Revive Used", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'HEX Revive Used': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("HEX Revive Used", eventProperties, "Yq8h0YyrdD", "2489dd029ea1c209dc608b5e55fe00baa58d6677a7d8c0c3793437a76675dfc2");
}
// destination Softgames
Softgames.logEvent("HEX Revive Used", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface HEXResourceActionProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  resourceActionType: ResourceActionTypeValueType;
  resourceActionTrigger: string;
  hexResourceUpdates: HEXResourceUpdates[] | null | undefined;
  levelId: string;
  levelNumber: number;
  levelAttemptId: string;
  hexResourceInventory: HEXResourceInventory[];
  transactionId: string | null | undefined;
  hexGameEventId: string | null | undefined;
}
/**
 * HEX Resource Action: Fires when a resource is consumed or gained
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.resourceActionType: Denotes the type of sink/source transaction that modified any resource in the user's inventory. For example watching an ad, purchasing an IAP or consuming a booster.
 * @param properties.resourceActionTrigger: The name of the game mechanic that incentivized the user to spend currency or triggered the reward of a resource.
 * For example spending coins to play another level could be called 'play-level'.
 * @param properties.hexResourceUpdates: A list of sink/source actions, that affected to amount of Resources in the user's inventory.
 * Amount should be negative for CONSUMED resources and positive for RECEIVED resources.
 * @param properties.levelId: Unique and persistent identifier of a single level (independent of an attempt)
 * @param properties.levelNumber: The number of the level
 * @param properties.levelAttemptId: Unique identifier of a single level attempt (to map Level Started, Level Finished and other events)
 * @param properties.hexResourceInventory: A list of the current amount of each resource in the user's inventory.
 * @param properties.transactionId: Unique transaction identifier for a single purchase within the IAP process, e.g. the paymentID in case of Facebook.
 * @param properties.hexGameEventId: ID of in-game event instance
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/DfS7aE51ZD}
 */
export function hexResourceAction(properties: HEXResourceActionProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "KG11eHIZr", name: "Resource Action Type", value: properties.resourceActionType});
eventPropertiesArray.push({id: "yfBdhcxqW", name: "Resource Action Trigger", value: properties.resourceActionTrigger});
properties.hexResourceUpdates !== undefined && properties.hexResourceUpdates !== null ?
  eventPropertiesArray.push({id: "UKpFRKPC0", name: "HEX Resource Updates", value: properties.hexResourceUpdates.map(function(value) { return {
      "HEX Resource Type": value.hexResourceType,
      "Amount": value.amount,
  }
})}) :
eventPropertiesArray.push({id: "UKpFRKPC0", name: "HEX Resource Updates", value: null});
eventPropertiesArray.push({id: "YyMk6EdDUR", name: "Level Id", value: properties.levelId});
eventPropertiesArray.push({id: "bP1jHNEg5", name: "Level Number", value: properties.levelNumber});
eventPropertiesArray.push({id: "YigUD3Pqm", name: "Level Attempt Id", value: properties.levelAttemptId});
eventPropertiesArray.push({id: "TCii5yrRnFFtdnNc181cs", name: "HEX Resource Inventory", value: properties.hexResourceInventory.map(function(value) { return {
    "HEX Resource Type": value.hexResourceType,
    "Amount": value.amount,
}
})});
properties.transactionId !== undefined && properties.transactionId !== null ?
  eventPropertiesArray.push({id: "asmftv_hZQ", name: "Transaction Id", value: properties.transactionId}) :
  eventPropertiesArray.push({id: "asmftv_hZQ", name: "Transaction Id", value: null});
properties.hexGameEventId !== undefined && properties.hexGameEventId !== null ?
  eventPropertiesArray.push({id: "7omr4Atb3ocZcE9I-M6Pv", name: "HEX Game Event ID", value: properties.hexGameEventId}) :
  eventPropertiesArray.push({id: "7omr4Atb3ocZcE9I-M6Pv", name: "HEX Game Event ID", value: null});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  messages = messages.concat(assertHEXResourceUpdatesOptional(properties.hexResourceUpdates));
  messages = messages.concat(assertHEXResourceInventory(properties.hexResourceInventory));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "DfS7aE51ZD", "9a66366c0c0dd00fa8a52bdc2d1227993a95514ed45efa13f576d7c5f689724a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("HEX Resource Action", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("DfS7aE51ZD", "HEX Resource Action", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'HEX Resource Action': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("HEX Resource Action", eventProperties, "DfS7aE51ZD", "9a66366c0c0dd00fa8a52bdc2d1227993a95514ed45efa13f576d7c5f689724a");
}
// destination Softgames
Softgames.logEvent("HEX Resource Action", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface HexDioramaCompletedProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  hexDioramaCompleted: number;
}
/**
 * Hex Diorama Completed: Called when a player fully completes a Diorama.
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.hexDioramaCompleted: The # of the last Diorama finished by the player.
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/ziwbgc5lgk}
 */
export function hexDioramaCompleted(properties: HexDioramaCompletedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "5X7s9cLMMo", name: "Hex Diorama Completed", value: properties.hexDioramaCompleted});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ziwbgc5lgk", "5549b371af126e8cc09b75aa9bebcfb88ed5867dbbfdd4126513e99d154c192c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Hex Diorama Completed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ziwbgc5lgk", "Hex Diorama Completed", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Hex Diorama Completed': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Hex Diorama Completed", eventProperties, "ziwbgc5lgk", "5549b371af126e8cc09b75aa9bebcfb88ed5867dbbfdd4126513e99d154c192c");
}
// destination Softgames
Softgames.logEvent("Hex Diorama Completed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface HEXTileRVUsedProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  levelAttemptId: string;
  hexTileRvTrigger: string;
}
/**
 * HEX Tile RV Used: Fires when player unlocks RV tile on the level
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.levelAttemptId: Unique identifier of a single level attempt (to map Level Started, Level Finished and other events)
 * @param properties.hexTileRvTrigger: Trigger for unlocking RV tile
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/MI8JEO0u1OC}
 */
export function hexTileRvUsed(properties: HEXTileRVUsedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "YigUD3Pqm", name: "Level Attempt Id", value: properties.levelAttemptId});
eventPropertiesArray.push({id: "UdlSO5_e8", name: "HEX Tile RV Trigger", value: properties.hexTileRvTrigger});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "MI8JEO0u1OC", "ae52ee54faef79d5daf4d7e6010cf3faa31145b9e455d7d407065924f0a26f99", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("HEX Tile RV Used", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("MI8JEO0u1OC", "HEX Tile RV Used", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'HEX Tile RV Used': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("HEX Tile RV Used", eventProperties, "MI8JEO0u1OC", "ae52ee54faef79d5daf4d7e6010cf3faa31145b9e455d7d407065924f0a26f99");
}
// destination Softgames
Softgames.logEvent("HEX Tile RV Used", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OfferActionProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  offerId: string;
  offerImpressionId: string | null | undefined;
  offerAction: OfferActionValueType;
  offerSegmentation: OfferSegmentation[] | null | undefined;
}
/**
 * Offer Action: Fires when IAP offer gets shown or clicked.
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.offerId: Unique identifier of the offer.
 * @param properties.offerImpressionId: Unique identifier of the impression. Generated at Show. Should be later send with Click and Purchase Finished event as well.
 * @param properties.offerAction: Name of action that triggered event.
 * @param properties.offerSegmentation: Rules and value of segmented offers.
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/WgCcFciOHhdpvqdOuQsvu}
 */
export function offerAction(properties: OfferActionProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "5w-3fG5OFiwADBxrpylT5", name: "Offer Id", value: properties.offerId});
properties.offerImpressionId !== undefined && properties.offerImpressionId !== null ?
  eventPropertiesArray.push({id: "INzWGmsjWZqUtcQ40834F", name: "Offer Impression Id", value: properties.offerImpressionId}) :
  eventPropertiesArray.push({id: "INzWGmsjWZqUtcQ40834F", name: "Offer Impression Id", value: null});
eventPropertiesArray.push({id: "XYMnEcP4U9H3_CKMJHExM", name: "Offer Action", value: properties.offerAction});
properties.offerSegmentation !== undefined && properties.offerSegmentation !== null ?
  eventPropertiesArray.push({id: "mcwTOSg7fE3vdE4jyqaoL", name: "Offer Segmentation", value: properties.offerSegmentation.map(function(value) { return {
      "Name": value.name,
      "Value": value.value,
  }
})}) :
eventPropertiesArray.push({id: "mcwTOSg7fE3vdE4jyqaoL", name: "Offer Segmentation", value: null});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  messages = messages.concat(assertOfferSegmentationOptional(properties.offerSegmentation));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "WgCcFciOHhdpvqdOuQsvu", "11760bc7b54efddf086c6518205b361e91a3e38d4c2860199f4765f26ff6af74", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Offer Action", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("WgCcFciOHhdpvqdOuQsvu", "Offer Action", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'Offer Action': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Offer Action", eventProperties, "WgCcFciOHhdpvqdOuQsvu", "11760bc7b54efddf086c6518205b361e91a3e38d4c2860199f4765f26ff6af74");
}
// destination Softgames
Softgames.logEvent("Offer Action", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface HEXEventStartedProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  hexGameEventType: string;
  hexGameEventId: string;
}
/**
 * HEX Event Started: Event when user joins the in game event
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.hexGameEventType: Type of event (win streak, race event etc)
 * @param properties.hexGameEventId: ID of in-game event instance
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/3lJw5-dSM7EcS4GzCuVKJ}
 */
export function hexEventStarted(properties: HEXEventStartedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "0m2iHSMKLE1yOeqhq-61t", name: "HEX Game Event Type", value: properties.hexGameEventType});
eventPropertiesArray.push({id: "7omr4Atb3ocZcE9I-M6Pv", name: "HEX Game Event ID", value: properties.hexGameEventId});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "3lJw5-dSM7EcS4GzCuVKJ", "b3225d278004f352974f990d2c24290b1acf815288fd6a9ca990d2be3460c4eb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("HEX Event Started", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("3lJw5-dSM7EcS4GzCuVKJ", "HEX Event Started", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'HEX Event Started': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("HEX Event Started", eventProperties, "3lJw5-dSM7EcS4GzCuVKJ", "b3225d278004f352974f990d2c24290b1acf815288fd6a9ca990d2be3460c4eb");
}
// destination Softgames
Softgames.logEvent("HEX Event Started", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface HEXEventFinishedProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  hexGameEventType: string;
  hexGameEventProgress: number;
  hexGameEventId: string;
  hexGameEventPlayerPlacement: number | null | undefined;
}
/**
 * HEX Event Finished: Event when in game event has finished
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.hexGameEventType: Type of event (win streak, race event etc)
 * @param properties.hexGameEventProgress: Player progress in the in-game event
 * @param properties.hexGameEventId: ID of in-game event instance
 * @param properties.hexGameEventPlayerPlacement: Placement of the player in event (1st, 2nd, 3rd... etc)
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/rptmDH-CKQ3zsGY-NrnNT}
 */
export function hexEventFinished(properties: HEXEventFinishedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "0m2iHSMKLE1yOeqhq-61t", name: "HEX Game Event Type", value: properties.hexGameEventType});
eventPropertiesArray.push({id: "BtXGfVT2gZTl9rVidGPfK", name: "HEX Game Event Progress", value: properties.hexGameEventProgress});
eventPropertiesArray.push({id: "7omr4Atb3ocZcE9I-M6Pv", name: "HEX Game Event ID", value: properties.hexGameEventId});
properties.hexGameEventPlayerPlacement !== undefined && properties.hexGameEventPlayerPlacement !== null ?
  eventPropertiesArray.push({id: "98VVInSFCnku8Jk_9JcsR", name: "HEX Game Event Player Placement", value: properties.hexGameEventPlayerPlacement}) :
  eventPropertiesArray.push({id: "98VVInSFCnku8Jk_9JcsR", name: "HEX Game Event Player Placement", value: null});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "rptmDH-CKQ3zsGY-NrnNT", "2de4445bd6527ff13d33f0793e7af3f9db406ad15955e97d5a4232159a05bcb2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("HEX Event Finished", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("rptmDH-CKQ3zsGY-NrnNT", "HEX Event Finished", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'HEX Event Finished': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("HEX Event Finished", eventProperties, "rptmDH-CKQ3zsGY-NrnNT", "2de4445bd6527ff13d33f0793e7af3f9db406ad15955e97d5a4232159a05bcb2");
}
// destination Softgames
Softgames.logEvent("HEX Event Finished", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface HEXASeasonPassProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  seasonPassId: string;
  seasonPassPoints: number;
  seasonPassStatusContext: SeasonPassStatusContextValueType;
  seasonPassPointsReceived: number | null | undefined;
  productId: string | null | undefined;
}
/**
 * HEXA Season Pass: Fires when a user opts in a Season Pass (Season Pass Start), when a user's Season Pass points are updated (Points Update) and when the Season Pass is purchased (Season Pass Purchase).
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.seasonPassId: The ID of the current Season Pass.
 * @param properties.seasonPassPoints: Total Season Pass Points the user gathered the moment of the event
 * @param properties.seasonPassStatusContext: A string indicating the season pass update status
 * @param properties.seasonPassPointsReceived: The amount of season pass points received during 'Points Update' context.
 * @param properties.productId: The ID of the IAP as defined internally at Softgames, to have a unified handle of a product across different platforms.
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/uN7MHLTk-pv9f9IjVA0B9}
 */
export function hexaSeasonPass(properties: HEXASeasonPassProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
properties.metaProperties !== undefined && properties.metaProperties !== null ?
  eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
      "Meta Property Name": value.metaPropertyName,
      "Meta Property Value": value.metaPropertyValue,
  }
})}) :
eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
eventPropertiesArray.push({id: "4UejR_Kvq", name: "Season Pass ID", value: properties.seasonPassId});
eventPropertiesArray.push({id: "txlAGzSe0", name: "Season Pass Points", value: properties.seasonPassPoints});
eventPropertiesArray.push({id: "iu6uGUb7p", name: "Season Pass Status Context", value: properties.seasonPassStatusContext});
properties.seasonPassPointsReceived !== undefined && properties.seasonPassPointsReceived !== null ?
  eventPropertiesArray.push({id: "2PNgHfoq4", name: "Season Pass Points Received", value: properties.seasonPassPointsReceived}) :
  eventPropertiesArray.push({id: "2PNgHfoq4", name: "Season Pass Points Received", value: null});
properties.productId !== undefined && properties.productId !== null ?
  eventPropertiesArray.push({id: "ZNrRISMpO2", name: "Product Id", value: properties.productId}) :
  eventPropertiesArray.push({id: "ZNrRISMpO2", name: "Product Id", value: null});
eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "uN7MHLTk-pv9f9IjVA0B9", "e3c7414af086774b555183186a537e331d1e8a781792ac9e4cbbab05a309f84c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("HEXA Season Pass", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("uN7MHLTk-pv9f9IjVA0B9", "HEXA Season Pass", messages, eventPropertiesArray, userPropertiesArray, []);
}
// @ts-ignore
if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
  // throw exception if messages is not empty
  if (messages.length !== 0) {
    throw new Error("Error sending event 'HEXA Season Pass': " + messages[0]!.message)
}
} else {
  messages.forEach(function(m) {
    console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
});
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("HEXA Season Pass", eventProperties, "uN7MHLTk-pv9f9IjVA0B9", "e3c7414af086774b555183186a537e331d1e8a781792ac9e4cbbab05a309f84c");
}
// destination Softgames
Softgames.logEvent("HEXA Season Pass", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface HEXCollectionEventTokenUpdateProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  hexCollectionEventTokenAmount: number;
  gameEventId: string;
  levelAttemptId: string;
}
/**
 * HEX Collection Event Token Update: Event is designed to track user interactions during active Collection Event feature. Players earn event tokens by clearing stacks of 10 or more hexes of a designated color during core gameplay. 
 * Event should be triggered only if tokens are rewarded to the player which happens only if the level is won.
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.hexCollectionEventTokenAmount: The amount of event tokens earned after each level won
 * @param properties.gameEventId: A uniquer identifier for each in-game event. This property should be used for any event which will be implemented across all games. 
 * It is generated by the games and should be unique for each event instance.
 * @param properties.levelAttemptId: Unique identifier of a single level attempt (to map Level Started, Level Finished and other events)
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/FlR22MVNiGXdwE0Gq7xJd}
 */
export function hexCollectionEventTokenUpdate(properties: HEXCollectionEventTokenUpdateProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
  properties.metaProperties !== undefined && properties.metaProperties !== null ?
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
        "Meta Property Name": value.metaPropertyName,
        "Meta Property Value": value.metaPropertyValue,
      }
    })}) :
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
  eventPropertiesArray.push({id: "QeFUl25ouexDxwpQTv9yu", name: "HEX Collection Event Token Amount", value: properties.hexCollectionEventTokenAmount});
  eventPropertiesArray.push({id: "tu5ZuUvCNZ-1I0zJMKdQC", name: "Game Event ID", value: properties.gameEventId});
  eventPropertiesArray.push({id: "YigUD3Pqm", name: "Level Attempt Id", value: properties.levelAttemptId});
  eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
  eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
  eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
  eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
  eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
  eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "FlR22MVNiGXdwE0Gq7xJd", "99af3f2e5220dc95c33f55e3c216aad9ed3b1fe911ca970521d36dfaf8ac6a4b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("HEX Collection Event Token Update", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("FlR22MVNiGXdwE0Gq7xJd", "HEX Collection Event Token Update", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'HEX Collection Event Token Update': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("HEX Collection Event Token Update", eventProperties, "FlR22MVNiGXdwE0Gq7xJd", "99af3f2e5220dc95c33f55e3c216aad9ed3b1fe911ca970521d36dfaf8ac6a4b");
    }
    // destination Softgames
    Softgames.logEvent("HEX Collection Event Token Update", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HEXCollectionEventFinishedProperties {
  clientTimestamp: number;
  metaProperties: MetaProperties[] | null | undefined;
  gameEventId: string;
  gameEventTier: number;
}
/**
 * HEX Collection Event Finished: The event should be sent when the 'Collection Event' ends
 * 
 * @param properties the properties associated with this event
 * @param properties.clientTimestamp: Current Epoch Unix Timestamp of the sending time of the event, independently from the local timezone of the user. e.g. '1663237751' (SECONDS SINCE JAN 01 1970. (UTC))
 * @param properties.metaProperties: A list of meta properties with their corresponding values.
 * @param properties.gameEventId: A uniquer identifier for each in-game event. This property should be used for any event which will be implemented across all games. 
 * It is generated by the games and should be unique for each event instance.
 * @param properties.gameEventTier: Current tier that the player reached in the game event
 * 
 * @see {@link https://www.avo.app/schemas/bJ0pj2RVS0ir3Kh8P6lq/events/OLf5oeSw3bfd79j-C6gcs}
 */
export function hexCollectionEventFinished(properties: HEXCollectionEventFinishedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "l6UOqaLQ8p", name: "Client Timestamp", value: properties.clientTimestamp});
  properties.metaProperties !== undefined && properties.metaProperties !== null ?
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: properties.metaProperties.map(function(value) { return {
        "Meta Property Name": value.metaPropertyName,
        "Meta Property Value": value.metaPropertyValue,
      }
    })}) :
    eventPropertiesArray.push({id: "tV7TWP7c1", name: "Meta Properties", value: null});
  eventPropertiesArray.push({id: "tu5ZuUvCNZ-1I0zJMKdQC", name: "Game Event ID", value: properties.gameEventId});
  eventPropertiesArray.push({id: "Kzwh-5JTl3AiphJmIQdoc", name: "Game Event Tier", value: properties.gameEventTier});
  eventPropertiesArray.push({id: "LLG3-od944", name: "Session Id", value: sysSessionId});
  eventPropertiesArray.push({id: "-NU9-A0RrZ", name: "Game Slug", value: sysGameSlug});
  eventPropertiesArray.push({id: "ydnvCQvhZi", name: "Game Version", value: sysGameVersion});
  eventPropertiesArray.push({id: "aKTZtLYazA", name: "Platform Name", value: sysPlatformName});
  eventPropertiesArray.push({id: "oalnujTnf0", name: "Schema Version", value: sysSchemaVersion});
  eventPropertiesArray.push({id: "lEP761GBc_", name: "Environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertMetaPropertiesOptional(properties.metaProperties));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "OLf5oeSw3bfd79j-C6gcs", "d1dbb6e4ce906f4ae090157fc54a3f552bc1e37c40d57fd4b0acc64a52719f17", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("HEX Collection Event Finished", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("OLf5oeSw3bfd79j-C6gcs", "HEX Collection Event Finished", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'HEX Collection Event Finished': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("HEX Collection Event Finished", eventProperties, "OLf5oeSw3bfd79j-C6gcs", "d1dbb6e4ce906f4ae090157fc54a3f552bc1e37c40d57fd4b0acc64a52719f17");
    }
    // destination Softgames
    Softgames.logEvent("HEX Collection Event Finished", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  GameSlug,
  UIElementAction,
  PurchaseResponse,
  ResourceActionType,
  AdNetwork,
  PaymentProvider,
  AdResponse,
  OfferAction,
  SplitTestDistribution,
  PlatformName,
  SeasonPassStatusContext,
  AssetQuality,
  BackendName,
  Environment,
  ProductType,
  SchemaVersion,
  HEXResourceType,
  AdType,
  gameInitialized,
  purchaseFinished,
  adFinished,
  splitTest,
  cheatsEnabled,
  nativeAppLaunched,
  uiInteraction,
  playerAttribution,
  hexLevelStarted,
  hexLevelWon,
  hexLevelLost,
  hexReviveShown,
  hexReviveUsed,
  hexResourceAction,
  hexDioramaCompleted,
  hexTileRvUsed,
  offerAction,
  hexEventStarted,
  hexEventFinished,
  hexaSeasonPass,
  hexCollectionEventFinished,
  hexCollectionEventTokenUpdate,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["gameInitialized","purchaseFinished","adFinished","splitTest","cheatsEnabled","nativeAppLaunched","uiInteraction","playerAttribution","hexLevelStarted","hexLevelWon","hexLevelLost","hexReviveShown","hexReviveUsed","hexResourceAction","hexDioramaCompleted","hexTileRvUsed","offerAction","hexEventStarted","hexEventFinished","hexaSeasonPass","hexCollectionEventFinished","hexCollectionEventTokenUpdate"]
